import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SubscriberDocumentsResponseDto } from '../types';

interface ToDoListState {
  subscriberDocuments: SubscriberDocumentsResponseDto;
}

const initialState: ToDoListState = {
  subscriberDocuments: {
    document_requests: {
      subscriber: [],
      dependents: {},
    },
    combine_request_ids: [],
    document_types: [],
    latest_pending_date: '',
    pending_requests: [],
  },
};

const toDoListSlice = createSlice({
  name: 'toDoList',
  initialState,
  reducers: {
    setSubscriberDocuments: (state, { payload }: PayloadAction<any>) => {
      state.subscriberDocuments = payload;
    },
  },
});

const { reducer, actions } = toDoListSlice;

// Actions
export const { setSubscriberDocuments } = actions;

export const toDoListReducer = reducer;
